var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pet-mine"},[_c('div',{staticClass:"tag"},[_c('BaseTopTabs',{attrs:{"tabs":_vm.tabs,"color":"#1989fa","bgColor":"#fff"},on:{"onClick":_vm.onclick}})],1),_c('div',{staticClass:"goods"},[(_vm.goodsList.length!=0)?_c('goodItem',{attrs:{"goods":_vm.goodsList}}):_c('van-empty',{attrs:{"description":"暂无数据"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }